import React, { useEffect, useState } from "react";
import IncludeSideBar from "../../../Components/Sidebar/IncludeSideBar";
import { getEngagementStats } from "../../../apis/dashboard";
import "../Overview/Analytics.css";

const EngagementStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [period, setPeriod] = useState("daily");

  const fetchStats = async () => {
    try {
      setLoading(true);
      const response = await getEngagementStats({ period });
      setStats(response?.data || null);
      setError(null);
    } catch (err) {
      console.error("Error fetching engagement stats:", err);
      setError("Failed to load engagement data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, [period]);

  return (
    <IncludeSideBar>
      <div className="analytics-page">
        <h2>Engagement Stats</h2>
        
        <div className="period-selector">
          <label>Select Period:</label>
          <select value={period} onChange={(e) => setPeriod(e.target.value)}>
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
          </select>
        </div>

        {loading ? (
          <div className="loading-container">
            <div className="loader"></div>
            <p>Loading engagement stats...</p>
          </div>
        ) : error ? (
          <div className="error-container">
            <p>{error}</p>
            <button onClick={fetchStats}>Retry</button>
          </div>
        ) : (
          <>
            {/* total */}
            <div className="analytics-section">
              <h3 className="section-title">App Activity</h3>
              <div className="analytics-grid">
                <div className="analytics-card professional">
                  <div className="card-header">
                    <h4>App Opens</h4>
                  </div>
                  <div className="card-metric">
                    <span className="metric-value">{stats?.appOpens ?? 0}</span>
                    <span className="metric-label">Total launches</span>
                  </div>
                </div>

                <div className="analytics-card professional">
                  <div className="card-header">
                    <h4>App Closes</h4>
                  </div>
                  <div className="card-metric">
                    <span className="metric-value">{stats?.appCloses ?? 0}</span>
                    <span className="metric-label">Sessions ended</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="analytics-section">
              <h3 className="section-title">Video Activity</h3>
              <div className="analytics-grid">
                <div className="analytics-card professional">
                  <div className="card-header">
                    <h4>Video Starts</h4>
                  </div>
                  <div className="card-metric">
                    <span className="metric-value">{stats?.videoStarts ?? 0}</span>
                    <span className="metric-label">Videos started</span>
                  </div>
                </div>

                <div className="analytics-card professional">
                  <div className="card-header">
                    <h4>Video Completed</h4>
                  </div>
                  <div className="card-metric">
                    <span className="metric-value">{stats?.videoCompleted ?? 0}</span>
                    <span className="metric-label">Fully watched</span>
                  </div>
                </div>

                <div className="analytics-card professional">
                  <div className="card-header">
                    <h4>Video Likes</h4>
                  </div>
                  <div className="card-metric">
                    <span className="metric-value">{stats?.videoLikes ?? 0}</span>
                    <span className="metric-label">Total likes</span>
                  </div>
                </div>

                <div className="analytics-card professional">
                  <div className="card-header">
                    <h4>Video Comments</h4>
                  </div>
                  <div className="card-metric">
                    <span className="metric-value">{stats?.videoComments ?? 0}</span>
                    <span className="metric-label">Total comments</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="analytics-section">
              <h3 className="section-title">Post Activity</h3>
              <div className="analytics-grid">
                <div className="analytics-card professional">
                  <div className="card-header">
                    <h4>Post Likes</h4>
                  </div>
                  <div className="card-metric">
                    <span className="metric-value">{stats?.picturePostLikes ?? 0}</span>
                    <span className="metric-label">Total likes</span>
                  </div>
                </div>

                <div className="analytics-card professional">
                  <div className="card-header">
                    <h4>Post Comments</h4>
                  </div>
                  <div className="card-metric">
                    <span className="metric-value">{stats?.picturePostComments ?? 0}</span>
                    <span className="metric-label">Total comments</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="analytics-section">
              <h3 className="section-title">Overview</h3>
              <div className="analytics-grid">
                <div className="analytics-card professional">
                  <div className="card-header">
                    <h4>Total Likes</h4>
                  </div>
                  <div className="card-metric">
                    <span className="metric-value">{stats?.totalLikes ?? 0}</span>
                    <span className="metric-label">All content</span>
                  </div>
                </div>

                <div className="analytics-card professional">
                  <div className="card-header">
                    <h4>Total Comments</h4>
                  </div>
                  <div className="card-metric">
                    <span className="metric-value">{stats?.totalComments ?? 0}</span>
                    <span className="metric-label">All content</span>
                  </div>
                </div>

                <div className="analytics-card professional">
                  <div className="card-header">
                    <h4>Shares</h4>
                  </div>
                  <div className="card-metric">
                    <span className="metric-value">{stats?.totalShares ?? 0}</span>
                    <span className="metric-label">Total shares</span>
                  </div>
                  <div className="card-breakdown">
                    <span>Profile: {stats?.profileShares ?? 0}</span>
                    <span>Hashtag: {stats?.hashtagShares ?? 0}</span>
                    <span>Audio: {stats?.audioShares ?? 0}</span>
                    <span>Posts: {stats?.picturePostShares ?? 0}</span>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </IncludeSideBar>
  );
};

export default EngagementStats;
